"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextToolbar = void 0;
var react_1 = __importStar(require("react"));
var slate_react_1 = require("slate-react");
var mobx_react_1 = require("mobx-react");
var dynamic_1 = require("@vanilla-extract/dynamic");
var react_resize_detector_1 = __importDefault(require("react-resize-detector"));
var slate_1 = require("slate");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var TextToolbarUI_1 = require("./TextToolbarUI");
var FocusManager_1 = require("./FocusManager");
var GetSelectedTextWidgets_1 = require("./GetSelectedTextWidgets");
var FilterableColorProvider_1 = require("Project/QwilrEditor/Styling/FilterableColorProvider");
var TextToolbarUI_css_1 = require("./TextToolbarUI.css");
var styles = __importStar(require("./TextToolbar.css"));
exports.TextToolbar = (0, mobx_react_1.observer)(function (props) {
    return (react_1.default.createElement(ToolbarPositioner, __assign({}, props, { editorFocused: props.selectionStore.focussed, selectionStoreCurrentSelection: props.selectionStore.currentSelection })));
});
var ToolbarPositioner = function (_a) {
    var _b;
    var blockStore = _a.blockStore, editorFocused = _a.editorFocused, editorElem = _a.editorElem, widgetManager = _a.widgetManager, toolbarFeatures = _a.toolbarFeatures, selectionStoreCurrentSelection = _a.selectionStoreCurrentSelection, setShowSelectionDecorator = _a.setShowSelectionDecorator;
    var editor = (0, slate_react_1.useSlate)();
    var colorProvider = (0, FilterableColorProvider_1.useFilterableColorProvider)();
    var _c = __read((0, react_1.useState)(), 2), selectionRect = _c[0], setSelectionRect = _c[1];
    var _d = __read((0, react_1.useState)(0), 2), toolbarWidth = _d[0], setToolbarWidth = _d[1];
    var _e = __read((0, react_1.useState)(false), 2), isToolbarFocused = _e[0], setIsToolbarFocused = _e[1];
    var positioningDivRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (editor.selection && !slate_1.Range.isCollapsed(editor.selection)) {
            try {
                var domRange = slate_react_1.ReactEditor.toDOMRange(editor, editor.selection);
                setSelectionRect(domRange.getBoundingClientRect());
            }
            catch (_a) {
                setSelectionRect(undefined);
            }
        }
        else {
            setSelectionRect(undefined);
        }
    }, [editor, editor.selection, selectionStoreCurrentSelection]);
    var selectedTextWidgets = (0, react_1.useMemo)(function () {
        return (0, GetSelectedTextWidgets_1.getSelectedTextWidgets)(editor, colorProvider, blockStore);
    }, [editor, editor.selection, colorProvider, blockStore]);
    var toolbarPosition = (0, react_1.useMemo)(getToolbarPosition, [
        isToolbarFocused,
        selectedTextWidgets,
        editorFocused,
        editorElem,
        selectionRect,
        toolbarWidth,
    ]);
    function getToolbarPosition() {
        if (!isToolbarFocused && !editorFocused)
            return null;
        if (selectedTextWidgets.length === 0)
            return null;
        if (!selectionRect)
            return null;
        try {
            if (!positioningDivRef.current) {
                throw new Error("Could not find positioning element");
            }
            var editorRect = getEditorBoundingRect(editorElem);
            if (!editorRect) {
                throw new Error("editorElem does not exist");
            }
            var positionLeft = selectionRect.left - editorRect.left;
            var toolbarRightOverflow = positionLeft + toolbarWidth - editorRect.right;
            if (toolbarRightOverflow > 0) {
                positionLeft -= toolbarRightOverflow;
            }
            var positionTop = selectionRect.top - editorRect.top - TextToolbarUI_css_1.textToolbarHeight;
            return { top: positionTop, left: positionLeft };
        }
        catch (e) {
            console.error("Error positioning toolbar", e);
            return null;
        }
    }
    function onToolbarFocus() {
        setIsToolbarFocused(true);
    }
    function onToolbarBlur() {
        setShowSelectionDecorator(false);
        setIsToolbarFocused(false);
    }
    return (react_1.default.createElement(react_resize_detector_1.default, { handleHeight: false, handleWidth: true, skipOnMount: true, refreshMode: "throttle", refreshRate: 200, onResize: function (width) { return setToolbarWidth(width !== null && width !== void 0 ? width : 0); } },
        react_1.default.createElement("div", { className: styles.positioningDiv, ref: positioningDivRef, style: toolbarPosition
                ? (0, dynamic_1.assignInlineVars)((_b = {},
                    _b[styles.divLeft] = "".concat(toolbarPosition.left, "px"),
                    _b[styles.divTop] = "".concat(toolbarPosition.top, "px"),
                    _b))
                : undefined }, !!toolbarPosition && (react_1.default.createElement(FocusManager_1.FocusManager, { onFocusEnter: onToolbarFocus, onFocusLeave: onToolbarBlur },
            react_1.default.createElement(TextToolbarUI_1.TextToolbarUI, { widgetManager: widgetManager, toolbarFeatures: toolbarFeatures, blockStore: blockStore, selectedTextWidgets: selectedTextWidgets, hideToolbar: function () {
                    onToolbarBlur();
                    slate_1.Transforms.deselect(editor);
                }, anchorRef: positioningDivRef, onToolbarTopLevelFocus: function () { return setShowSelectionDecorator(true); } }))))));
};
function getEditorBoundingRect(editorElem) {
    if ((0, EditorTypes_1.isHTMLElement)(editorElem)) {
        return editorElem.getBoundingClientRect();
    }
    if (!!(editorElem === null || editorElem === void 0 ? void 0 : editorElem.current)) {
        return editorElem.current.getBoundingClientRect();
    }
    return null;
}
